import { render, staticRenderFns } from "./EventGeneralInfo.vue?vue&type=template&id=33191982&"
import script from "./EventGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./EventGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./EventGeneralInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports